import { render } from "./Vorstand.vue?vue&type=template&id=4c5fee19"
import script from "./Vorstand.vue?vue&type=script&lang=js"
export * from "./Vorstand.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\afm.git - Kopie\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__